import store from "lib/store";
import {storageInit} from "lib/storage";

import {
  setBasePath, setSiteName,
} from "reducers/appstate";


import {
  setSchoolPublicInfo, errSchoolPublicInfo,
} from "reducers/schoolinfo";


import SchoolPublicInfoAPI from "api/schoolpublicinfo_api"


/**
 * API
 */
class API {
  static init() {
    const currentPath = window.location.pathname.split("/");
    const basePath = "/" + currentPath[1] + "/" + currentPath[2];
    const siteName = currentPath[1];

    storageInit(basePath);
    store.dispatch(setBasePath(basePath));
    store.dispatch(setSiteName(siteName));

    // 公開施設情報をロード
    SchoolPublicInfoAPI.get(
      {
        siteName: siteName
      }
    )
    .then((schoolPublicInfo) => {
      store.dispatch(setSchoolPublicInfo(schoolPublicInfo));
    })
    .catch(() => {
      store.dispatch(errSchoolPublicInfo());
    });
  }
}


export {
  API as default,
  API
};
